<nb-card id="{{question.type}}-question-card" class="question-card" [formGroup]="formControlsInfo.formGroup">
	<nb-card-body>
		<div class="question-header">
			<h6 id="{{question.type}}-question" class="question">{{ translator.getText(question) }}</h6>
			@if (translator.hasExplanation(question)) {
				<nb-icon icon="info-outline" [nbPopover]="explanationPopover" nbPopoverPlacement="right"></nb-icon>
			}
		</div>

		@for (answer of question.answers; track answer; let isLast = $last) {
			@if (question.type != NOTES_FOR_CLIENT_SERVICES) {
				<div class="answer-radio">
					<label class="radio-label">{{ answer.standardName | standardName }}</label>
					<nb-radio-group [id]="question.type"
									name="answer-{{RANDOM}}-{{answer.standardName}}" status="primary"
									[formControlName]="formControlsInfo.formControlsForAnswer.get(answer.standardName)"
									[disabled]="blockInputs || shouldDisableRadio(formControlsInfo.formControlsForAnswer.get(answer.standardName))">
						<nb-radio name="answer-yes" status="primary" [value]="true">{{ positiveText }}</nb-radio>
						<nb-radio name="answer-no" status="primary" [value]="false">{{ negativeText }}</nb-radio>
					</nb-radio-group>
				</div>
			}
			@if (!isLast) {
				<div class="divider"></div>
			}
		}

		@if (!blockInputs || !!question.comment) {
			<textarea #commentTextArea id="{{question.type}}-comment-area" class="comment-area" [ngClass]="{disabled: blockInputs}" nbInput fullWidth
					  placeholder="Place your comments here" [formControlName]="formControlsInfo.formControlForComment" maxlength="500" (scroll)="autoResizeOnScroll($event)"
					  [readOnly]="blockInputs" [attr.disabled]="blockInputs ? '' : null"></textarea>
		}
	</nb-card-body>
</nb-card>

<ng-template #explanationPopover>
	<nb-card class="explanation-card">
		<nb-card-body class="explanation-body">
			<div>
				<div class="label" [innerHTML]="translator.getExplanation(question)"></div>
				<nb-icon class="close-icon" icon="close-circle-outline" (click)="popover.hide()"></nb-icon>
			</div>
		</nb-card-body>
	</nb-card>
</ng-template>
